export default __webpack_public_path__ + "static/media/dropbox-deleted.094653cb.png";